import { Button } from '@ophelos/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from '@/hooks/useTranslation';

interface PaymentOptionViewProps {
  title: string;
  /** Absent when paying in full is blocked, so there is nothing to return to. */
  onClose?: () => void;
  children: ReactNode;
  'data-testid'?: string;
}

/** Takes over the payment panel for one way of paying; closing returns to paying in full. */
export function PaymentOptionView({ title, onClose, children, 'data-testid': testId }: PaymentOptionViewProps) {
  const { t } = useTranslation();
  return (
    <div className="flex-1 min-h-0 flex flex-col w-full" data-testid={testId}>
      {/* Same gutters and column as the option bodies, so the title sits flush with their fields. */}
      <div className="px-2 xs:px-4 pb-4">
        <div className="max-w-md w-full mx-auto flex items-center gap-3">
          {onClose && (
            <Button variant="outline" size="icon-sm" className="rounded-full" onClick={onClose} aria-label={t('common.back')} data-testid="payment-option-back">
              <ChevronLeft />
            </Button>
          )}
          <h2 className="text-base font-semibold">{title}</h2>
        </div>
      </div>
      {children}
    </div>
  );
}
